<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  BModal, BButton, BAlert, BRow, BCol, BFormGroup, BFormCheckbox, AlertPlugin,
} from 'bootstrap-vue';
import vSelect from 'vue-select';

import { required, email } from '@validations';

import axios from '@/libs/axios';
import ModalAdd from '@/views/app/operacoes/pic/list/ModalAdd.vue';
import ModalReprovacao from '../ModalReprovacao.vue';

export default {
  components: {
    ModalAdd,
    BModal,
    BButton,
    BAlert,
    vSelect,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    ModalReprovacao,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        tipopicid: '',
        tipopicdescricao: '',
        tipopicinformavalorbrutoliquido: '',
        tipopictipocontrole: '',
      }),
      require: true,
    },
    tabprecoid: {
      type: String,
      default: null,
      require: false,
    },
    titleModal: {
      type: String,
      default: null,
      require: false,
    },
    idModal: {
      type: String,
      default: null,
      require: false,
    },
    labelBtnOk: {
      type: String,
      default: null,
      require: false,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    dataForm: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    async fecharModal() {
      this.$emit('cancel');
      this.$bvModal.hide(this.idModal);
    },
    toUpperCase() {
      this.dataForm.tipopicid = this.dataForm.tipopicid.toUpperCase();
    },
  },
};
</script>

<template>

  <b-modal
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      :id="idModal"
      :title="titleModal"
      cancel-variant="secondary"
      body-bg-variant="light"
      cancel-title="Cancelar"
      @cancel="$emit('cancel')"
      @close="$emit('cancel')"
  >
    <template #modal-footer>
      <b-row>
        <b-col cols="4">
          <!-- Primeiro botão extra -->
          <b-button variant="primary" @click="fecharModal">Voltar</b-button>
        </b-col>
      </b-row>
    </template>
    <validation-observer ref="refFormData">
      <b-form @submit.prevent>
        <b-row>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Codigo Item"
                label-for="itemid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.itemid"
                    id="itemid"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Descrição Item"
                label-for="itemid"
            >
              <validation-provider
                  #default="{ errors }"
                  name="Descrição"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.DadosItem.item_descricao"
                    id="itemid"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Digite a descrição"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
<!--          <b-col-->
<!--              cols="4"-->
<!--              class="mb-1"-->
<!--          >-->
<!--            <b-form-group-->
<!--                label="Sequencia"-->
<!--                label-for="picitemsequencia"-->
<!--            >-->
<!--              <validation-provider-->
<!--                  #default="{ errors }"-->
<!--                  name="Descrição"-->
<!--                  rules="required"-->
<!--              >-->
<!--                <b-form-input-->
<!--                    v-model="dataForm.picitemsequencia"-->
<!--                    id="picitemsequencia"-->
<!--                    :state="errors.length > 0 ? false : null"-->
<!--                    placeholder="Digite a sequencia"-->
<!--                    disabled-->
<!--                />-->
<!--                <small class="text-danger">{{ errors[0] }}</small>-->
<!--              </validation-provider>-->
<!--            </b-form-group>-->
<!--          </b-col>-->
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Quantidade"
                label-for="picitemquantidade"
            >
              <validation-provider
                  #default="{ errors }"
                  name="picitemquantidade"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.picitemquantidade"
                    id="picitemquantidade"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Saldo"
                label-for="picitemquantidadesaldo"
            >
              <validation-provider
                  #default="{ errors }"
                  name="picitemquantidadesaldo"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.picitemquantidade"
                    id="picitemquantidadesaldo"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Desconto %"
                label-for="picitemporcentagem"
            >
              <validation-provider
                  #default="{ errors }"
                  name="picitemporcentagem"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.picitemporcentagem"
                    id="picterminovalidpicitemporcentagem"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Valor PIC"
                label-for="picitemvalorpic"
            >
              <validation-provider
                  #default="{ errors }"
                  name="picitemvalorpic"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.picitemvalorpic"
                    id="picterminovalidpicitemvalorpicade"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Total Mercadoria"
                label-for="pictotalmercadoria"
            >
              <validation-provider
                  #default="{ errors }"
                  name="pictotalmercadoria"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.picitemtotalmercadoria"
                    id="pictotalmercadoria"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
              cols="4"
              class="mb-1"
          >
            <b-form-group
                label="Situação"
                label-for="picitemsituacao"
            >
              <validation-provider
                  #default="{ errors }"
                  name="picitemsituacao"
                  rules="required"
              >
                <b-form-input
                    v-model="dataForm.picitemsituacao"
                    id="picitemsituacao"
                    :state="errors.length > 0 ? false : null"
                    disabled
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

  </b-modal>
</template>
